import React, { Component} from 'react';
import moment from 'moment';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import MoreVertIcon from 'material-ui-icons/MoreVert';

class DisciplineItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    }
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  render() {
    const { discipline } = this.props;
    const is_checked = _.includes(this.props.discipline_ids, discipline.id);
    const ITEM_HEIGHT = 48;
    const { anchorEl } = this.state;
    return (
      <tr>
        <td>
          { !(new Date(discipline.start_date) <= new Date() && new Date(discipline.end_date) >= new Date()) &&
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              checked={is_checked}
              key={discipline.id}
            />
            <label for="filled-in-box10" onClick={() => this.props.checkedDisciplineIds(discipline.id)}></label>
          </p>
          }
        </td>
        <td>{discipline.title || 'N/A'}</td>
        <td>{discipline.discipline_type}</td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200
              }
            }}
          >
            <MenuItem onClick={() => this.props.navigateToDiscipline(discipline.id)}>
              Edit
            </MenuItem>
          </Menu>
        </td>
      </tr>

    );
  }
}

DisciplineItem.defaultProps = {};

DisciplineItem.propTypes = {};

export default DisciplineItem;



// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/ListDisciplines/DisciplineItem.jsx